import React from 'react';

const Mission = () => {
  return (
    <section id="mission-vision">
      <div className="container">
        <div>
          <h2>Mission</h2>
          <p>
            To raise awareness of National professional schools among high
            school students by organizing continuous orientation, follow-up, and
            preparation for competitive entrance examinations. We aim to provide
            the necessary support and guidance to help students successfully
            gain admission to their desired professional school.
          </p>
        </div>
        <div>
          <h2>Vision</h2>
          <p>
            To ensure that each student gets into their desired professional
            school, we aim to create a future where all students in Cameroon can
            pursue their chosen professional paths with access to top-notch
            preparation courses. We aspire to lead the way in exam preparation
            services, helping students achieve success and embodying our motto
            of 'one student one professional school'.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Mission;
